import { List } from 'immutable';

export const selectFiltered = state => ({ mDate }) => {
  return state[mDate.toDate().getTime()] || List();
};
